import React, {useState, useEffect} from 'react';
import Popup from "../Popup";
import FormHeader from "../form/Header";
import {useTranslation} from "react-i18next";
import {CentsToDollars} from "../../utils/formatPrice";
import {formatDate} from "../../utils/formatDate";
import {GetSellOrder} from "../../api/sell-orders/getSellOrder";
import SpecialtyItemsSection from "../sell-specialty-items/SpecialtyItemsSection";

const ViewOrder = ({order, onClose, ...props}) => {
    const { t } = useTranslation();
    const [fullOrder, setFullOrder] = useState('');
    const [loading, setLoading] = useState(false);

    const getFullOrder = async () => {
        if(order.id){
            setLoading(true);
            try {
                const {data} = await GetSellOrder({id:order.id});
                setFullOrder(data);
            }catch (err){
                console.log("Full order couldn't be fetched. " +  err.message);
            }
            setLoading(false)
        }
    }

    console.log(fullOrder)

    useEffect(()=> {
        getFullOrder();
    }, []);

    const cards = fullOrder?.cards ?? [];
    const cardFaceValue = cards.reduce((sum, card) => sum + (card.load_amount ?? 0), 0);
    const perCardFee = cards.length > 0
        ? Math.round((fullOrder?.total_service_fee ?? 0) / cards.length)
        : 0;

    return (
        <Popup size="large" withClose withOverlay onClose={onClose}>
            <FormHeader title={`Order ID: ${order.id}`}></FormHeader>

            <div className="mt-5">
                <p>{t("Order number")}: <strong>{order.id}</strong></p>
                <p>{t("Order date")}: <strong>{formatDate(order.created_at)}</strong></p>
                <p>{t("Type")}: <strong>{order.type}</strong></p>
                <p>{t("Status")}: <strong>{order.status}</strong></p>
                <p>{t("User")}: <strong>{order.created_by_name}</strong></p>
                <p>{t("Total Tender")}: <strong>{CentsToDollars(order.total_cost)}</strong></p>
                <p>{t("Client Company Name")}: <strong>{order.client_company_name}</strong></p>
                <p>{t("Office Name")}: <strong>{order.office_name}</strong></p>
                <p>{t("Transaction ID")}: <strong>{order.transaction_id}</strong></p>
                {loading && t("Loading additional data...")}
                {!loading && fullOrder &&
                    <>
                        {fullOrder.cards.length > 0 && <div className="mb-1">
                            <p>{t("Cards")}:</p>
                            <table>
                                <thead>
                                    <tr>
                                        <th>{t('PRN Number')}</th>
                                        <th>{t('Amount')}</th>
                                        <th>{t('Status')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {fullOrder.cards.map((card) => (
                                        <tr key={card.processor_reference}>
                                            <td>{card.processor_reference}</td>
                                            <td>{CentsToDollars(card.load_amount)}</td>
                                            <td>{card.status}</td>
                                        </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                        }

                        {fullOrder.specialty_items?.length > 0 &&
                            <div className="mb-1">
                                <p>{t("Specialty Items")}:</p>
                                <SpecialtyItemsSection lines={fullOrder.specialty_items} readOnly hideTitle/>
                            </div>
                        }

                        {fullOrder.payments.length > 0 && <div className="mb-1">
                            <p>{t("Payments")}:</p>
                            <table>
                                <thead>
                                <tr>
                                    <th>{t('Type')}</th>
                                    <th>{t('Confirmation Code')}</th>
                                    <th>{t('Amount')}</th>
                                </tr>
                                </thead>
                                <tbody>
                                {fullOrder.payments.map((payment) => (
                                    <tr key={payment.id}>
                                        <td>{payment.payment_type}</td>
                                        <td>{payment.confirmation_code}</td>
                                        <td>{CentsToDollars(payment.amount)}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                        }

                        {fullOrder.specialty_items?.length > 0 &&
                            <div className="mb-1">
                                <p>{t("Breakdown")}:</p>
                                <table>
                                    <tbody>
                                    {fullOrder.cards.length > 0 &&
                                        <tr>
                                            <td>{t("Card face value")}</td>
                                            <td>{CentsToDollars(cardFaceValue)}</td>
                                        </tr>
                                    }
                                    {fullOrder.cards.length > 0 &&
                                        <tr>
                                            <td>{t("Activation fee")} ({fullOrder.cards.length} {t("cards")} x {CentsToDollars(perCardFee)})</td>
                                            <td>{CentsToDollars(fullOrder.total_service_fee)}</td>
                                        </tr>
                                    }
                                    {fullOrder.cards.length > 0 &&
                                        <tr>
                                            <td>{t("Tax on activation fee")}</td>
                                            <td>{CentsToDollars(fullOrder.service_fee_tax)}</td>
                                        </tr>
                                    }
                                    <tr>
                                        <td>{t("Specialty items")}</td>
                                        <td>{CentsToDollars(fullOrder.specialty_items_amount)}</td>
                                    </tr>
                                    <tr>
                                        <td>{t("Tax on specialty items")}</td>
                                        <td>{CentsToDollars(fullOrder.specialty_items_tax)}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>{t("Total Tender")}</strong></td>
                                        <td><strong>{CentsToDollars(fullOrder.total_cost)}</strong></td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        }
                    </>
                }
            </div>
        </Popup>
    );
};

export default ViewOrder;
